import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { chakra, Icon, Text } from '@chakra-ui/react';
import { BxsCloudUpload } from '../icons/BxsCloudUpload';
import { Link } from '../Link';
import { useAttachmentStyles } from './AttachmentContext';
export const AttachmentDropzone = ({ inputProps, isDragActive, }) => {
    const styles = useAttachmentStyles();
    const chooseFileText = useMemo(() => `Choose file${inputProps.multiple ? 's' : ''}`, [inputProps.multiple]);
    return (_jsxs(_Fragment, { children: [_jsx(chakra.input, { ...inputProps, "data-testid": inputProps.name }), _jsx(Icon, { "aria-hidden": true, as: BxsCloudUpload, __css: styles.icon }), isDragActive ? (_jsx(Text, { children: "Drop the file here ..." })) : (_jsxs(Text, { children: [_jsx(Link, { isDisabled: inputProps.disabled, children: chooseFileText }), " or drag and drop here"] }))] }));
};
